import {client} from "../store";


export const fetchFeatureFlags = () => async (dispatch) => {
  const response = await client.get("/feature-flags/");
  return dispatch({
    type: "SET_FEATURE_FLAGS",
    payload: response.data,
  });
}